import { useQuery } from '@apollo/client'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  CheckboxInputStyle,
  UncontrolledRadioInput,
} from '@src/components/Inputs'
import {
  OptionContentLabels,
  OptionLabel,
  PopoverOptionContainer,
} from '@src/components/BottomSheet/BottomSheet.styles'
import {
  OutletFulfilmentStateType,
  useOutletFulfilment,
} from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'

import { marketplaceIdServiceOverlayDocument } from '../MobileServiceOverlay/queries/__generated__/marketplaceIdServiceOverlay.graphql-interface'
import { UnavailableText } from '../CheckoutModal/FormElements.styles'

export const OutletFulfilmentSection: React.FC = () => {
  const { t } = useTranslation('serviceOverlay')

  const {
    outlet,
    setCurrentFulfilmentFromNarrowFulfilment,
    data: { currentFulfilment },
  } = useOutletFulfilment({
    stateType: OutletFulfilmentStateType.LOCAL,
  })

  const { narrowType: currentNarrowFulfilment } = currentFulfilment

  const marketplace = useQuery(marketplaceIdServiceOverlayDocument, {
    variables: { cname: window.location.hostname },
  })

  if (marketplace.loading || !marketplace.data) return null

  const fulfilmentLabels =
    outlet.orderability.prioritisedGenerallyAvailableFulfilmentMethods.map(
      method => ({
        label: t(method.toLowerCase()),
        value: method,
        isOrderable:
          outlet.orderability.prioritisedCurrentlyAvailableFulfilmentMethods.includes(
            method
          ),
      })
    )

  return (
    <>
      {fulfilmentLabels.map(option => (
        <PopoverOptionContainer key={option.label}>
          <UncontrolledRadioInput
            label={
              <OptionLabel>
                <OptionContentLabels>
                  <span>{option.label}</span>
                  {!option.isOrderable && (
                    <UnavailableText>
                      {t('currently_unavailable')}
                    </UnavailableText>
                  )}
                </OptionContentLabels>
              </OptionLabel>
            }
            style={CheckboxInputStyle.TICK}
            checked={currentNarrowFulfilment === option.value}
            onClick={() => {
              setCurrentFulfilmentFromNarrowFulfilment(option.value)
            }}
          />
          {option.value === 'TABLE' &&
            currentNarrowFulfilment === 'TABLE' &&
            outlet.isPendingTableNumbersEnabled &&
            outlet.isOpen && <h4>{outlet.pendingTableNumbersCustomText}</h4>}
        </PopoverOptionContainer>
      ))}
    </>
  )
}
